<template>
  <div class="shop-import">
    <div class="title">请上传EXCLE文件</div>
    <div class="import-area">
      <input ref="excel-upload-input" class="excel-upload-input" type="file" accept=".xlsx, .xls" @change="handleClick">
      <div class="drop" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover">
        <i class="el-icon-plus"></i>
        <span>或将Excle文件拖拽到这里</span>
        <span class="hint">单次最多支持上传200条店铺数据</span>
        <div class="btn-box">
          <el-button :loading="loading" type="primary" @click="handleUpload">上传文件</el-button>
          <el-button class="mr10" @click="onDownloadTemplate" :loading="downloadLoading" >下载模板文件</el-button>
        </div>
      </div>
    </div>

    <div class="table-box" v-if="tableTrData.length">
      <div class="title">店铺导览</div>
      <el-table
        ref="myTable"
        :header-cell-style="{ background:'#F2F3F5',height:'50px',border: '0'}"
        :data="tableTrData"
        empty-text="暂无数据"
        style="width: 100%; border: 1px solid #eee;"
        height="500"
      >
        <el-table-column
          v-for="(item, index) in tableThData"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <el-button @click="$router.back(-1)" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
    </div>
    <Dialog :maskClose="false" :dialogShow="isShowErrDialog" title="温馨提示" @maskClick="() => {isShowErrDialog = false}">
      <div class="dialog-box">
        <div class="dialog-content">
          <div>录入失败数据店铺编码：{{ errList }}</div>
          <div>失败原因：当前店铺编码已存在。</div>
        </div>
        <div class="dialog-button">
          <el-row class="button-div-row">
            <el-button type="primary" class="determine" @click="() => {isShowErrDialog = false}">确定</el-button>
          </el-row>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import Table from "@/components/Table/index";
import Dialog from "@/components/Dialog/index";
import { export_json_to_excel } from '@/utils/exportExcel'
import { api_getStoreImportTemplate, api_postBatchImportStore } from '@/api/finance'
import { downFile } from "@/utils";

export default {
  name: "shopImport",
  components: {
    Table,
    Dialog
  },
  data() {
    return {
      downloadLoading: false,
      loading: false,
      submitLoading: false,
      tableThData: [],
      tableTrData: [],
      excelData: [],
      errList: '',
      isShowErrDialog: false
    };
  },
  created() {},
  methods: {
    // 点击下载模板按钮
    async onDownloadTemplate() {
      this.downloadLoading = true
      try {
        let res = await api_getStoreImportTemplate()
        downFile(res)
        this.downloadLoading = false
      } catch (err) {
        this.downloadLoading = false
      }
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },

    // 文件拖拽事件
    handleDrop(e) {
      this.stopEvent(e)
      if (this.loading) return
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$message.error('仅支持上传一个文件!')
        return
      }
      const rawFile = files[0] // only use files[0]

      if (!this.isExcel(rawFile)) {
        this.$message.error('仅支持上传.xlsx，.xls格式文件')
        return false
      }

      this.upload(rawFile)
      this.stopEvent(e)
    },

    // 文件拖拽事件
    handleDragover(e) {
      this.stopEvent(e)
      e.dataTransfer.dropEffect = 'copy'
    },

    // 点击上传文件按钮
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },

    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0] // only use files[0]
      if (!rawFile) return
      this.upload(rawFile)
    },

    // 上传文件
    upload(rawFile) {
      this.$refs['excel-upload-input'].value = null // fix can't select the same excel
      this.readerData(rawFile)
    },

    readerData(rawFile) {
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' }) // 读取表格文件属性
          const firstSheetName = workbook.SheetNames[0] // 获取第一个sheet名
          const worksheet = workbook.Sheets[firstSheetName] // 获取第一个sheet数据

          const headers = this.getHeaderRow(worksheet) // 获取表格头部数据
          const results = XLSX.utils.sheet_to_json(worksheet) // 获取表格主体数据
          this.generateData({ headers, results }) // 产生json数据
          this.loading = false
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },

    // 获取表格头部数据
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },

    // 产生json数据
    generateData({ headers, results }) {
      this.excelData.headers = headers
      this.excelData.results = results.splice(0, 1)
      this.tableThData = this.excelData.headers.map(item => {
        return {
          label: this.excelData.results[0][item],
          prop: item
        }
      })
      this.tableTrData = results
      if (!results.length) {
        this.$baseMessage('表格无数据，请重新上传。', 'warning')
      }
    },

    // 点击提交
    async onSubmit() {
      if (this.tableTrData.length) {
        try {
          let res = await api_postBatchImportStore(this.tableTrData)
          console.log('res: ', res);
          if (res.length) {
            this.errList = res.join('、')
            this.isShowErrDialog = true
          } else {
            this.$baseMessage('操作成功', 'success')
            this.$router.back(-1)
          }
        } catch (err) {
          console.log('err: ', err);
        }
      }
    },

    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },

    // 阻止默认事件
    stopEvent(e) {
      e.stopPropagation()
      e.preventDefault()
    }
  },
};
</script>

<style lang="scss" scoped>
.shop-import {
  padding: 35px 20px;
  padding-bottom: 100px;

  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    .title-remark {
      color: #666666;
      font-size: 14px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }

  .table-box{
    margin-top: 20px;
    ::v-deep {
      .el-table{
        th.el-table__cell {
          .cell{
            color: #333;
            font-size: 14px;
            font-weight: 600;
            color: #333333;
          }
        }
      }
    }
  }

  .import-area {
    border: 1px solid #ccc;
    margin: 10px 0;
    margin-bottom: 20px;
    border-radius: 2px;

    .excel-upload-input{
      display: none;
      z-index: -9999;
    }

    .drop{
      width: 100%;
      height: 200px;
      margin: 0 auto;
      color: #bbb;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      i {
        font-size: 40px;
        color: #ccc;
        font-weight: 700;
        // margin: 20px 0;
      }

      span {
        margin-top: 20px;
        color: #999999;
        font-size: 12px;
      }

      .btn-box {
        margin-top: 20px;
      }

      .hint {
        color: #F74A4A;
        font-weight: 500;
      }
    }
  }

  .dialog-box {
    padding-top: 30px;

    .dialog-content {
      min-height: 100px;
      line-height: 40px;
      font-size: 14px;
      font-weight: 500;
    }

    .dialog-button {
      margin-top: 50px;

      .button-div-row {
        text-align: right;
      }
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    z-index: 100;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
